import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
 edit_user_main_details: { status: "idle" },
};

export const edit_user_main_details_Slice = createSlice({
 name: "edit_user_main_details",
 initialState,
 reducers: {
  success_edit_user_main_details: (state, action) => {
   state.edit_user_main_details = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_edit_user_main_details: (state, action) => {
   state.edit_user_main_details = { status: app_consts.FAIL, message: action.payload };
  },
  reset_edit_user_main_details: (state) => {
   state.edit_user_main_details = { status: app_consts.IDLE };
  },
  loading_edit_user_main_details: (state) => {
   state.edit_user_main_details = { status: app_consts.LOADING };
  },
 }
});

export const { success_edit_user_main_details, fail_edit_user_main_details, reset_edit_user_main_details, loading_edit_user_main_details } = edit_user_main_details_Slice.actions;

export default edit_user_main_details_Slice.reducer;